var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeppelinSetLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    enableBackground: "new 0 0 18 18",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.288,14.245L6.875,9.81C6.627,9.575,6.502,9.272,6.502,8.899c0-0.342,0.117-0.646,0.35-0.911h0.023l4.413-4.437 l0.374,0.351L7.25,8.316L7.227,8.339c-0.156,0.14-0.234,0.326-0.234,0.56c0,0.234,0.078,0.42,0.234,0.561l4.436,4.435 L11.288,14.245z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeppelinSetLeftIcon);
export default __webpack_public_path__ + "static/media/zeppelin-set-left-icon.e0ddd1cd.svg";
export { ForwardRef as ReactComponent };